export const targetsMessage = `Which of the following best describes your enterprise’s approach to aligning analytics 
to specific business objectives?`;

const targetsQ1 = `No targeting of opportunities.`;

const targetsQ2 = `Multiple disconnected targets, typically not of strategic importance.`;

const targetsQ3 = `Analytical efforts coalescing behind a small set of important targets.`;

const targetsQ4 = `Analytics centered on a few key business domains with explicit and ambitious outcomes`;

const targetsQ5 = `Analytics integral to the company’s distinctive capability and strategy`;

export const targetsQuestions = [ targetsQ1, targetsQ2, targetsQ3, targetsQ4, targetsQ5 ];
export const targetsQuestionWeight = 0.16;
export const targetsQuestionsScore = [ 0.16, 0.32, 0.48, 0.64, 0.80 ];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/data/targetsQuestion.ts